<div class="ets-host">
  
  <div [ngClass]="{'empty': !this.isEtsHost}" class="ets-host-header">
    
    <div class="part side left">
      
      <div *ngIf="this.isEtsHost" class="btn logo">
        <img src="assets/logo.png" style="margin-left: 3px">
      </div>
      
      <div *ngIf="this.securityContext.tradeButton" class="btn trading-pad">
        <dx-button
          (onClick)="this.toggleTradingPad()"
          class="ets-header-button trade"
          height="100%"
          text="Trade"
          width="100%"
        >
        </dx-button>
      </div>
      
      <div class="btn telegram" *ngIf="this.isEtsHost"><ets-telegram-connections></ets-telegram-connections></div>
      <div class="btn menu">
        <ets-host-menu *ngIf="this.securityContext.menuButton && this.isEtsHost"
                       [uniqueId]="'default-host-menu'"
                       class="ets-header-button"
        >
        </ets-host-menu>
      </div>
      
    </div>
    
    <div class="part side right">
      
      <div class="btn terminal-exit">
        <ets-terminal-exit
          (terminalExitRequest)="this.onTerminalExitRequestPressed($event)"
          *ngIf="this.securityContext.terminalExit"
          class="ets-header-button terminal-exit"
        >
        </ets-terminal-exit>
      </div>
      
      <div class="btn master-exit">
        <dx-button
          (onClick)="this.onMasterExitPressed()"
          [visible]="this.securityContext.masterExit"
          class="ets-header-button master-exit"
          height="100%"
          text="Master Exit"
          width="100%"
        >
        </dx-button>
      </div>
    </div>
  
  
  </div>
  
  <div [ngClass]="{'extended': !this.isEtsHost}" class="ets-host-content">
    
    <div *ngIf="this.isTradingPadVisible && this.securityContext.tradeButton" class="trading-pad-host">
      <ets-trading-pad></ets-trading-pad>
    </div>
    
    <div *ngIf="this.isEventStreamConnectionLost" id="ess-badge">{{ this.essConnectionLostMessage }}</div>
    
    <div *ngIf="this.isShellOffline" id="shell-badge">{{ this.shellOfflineMessage }}</div>
    
    <ets-layout-tabs
      (onAddTab)="this.onAddTabRequest()"
      (onCloseTab)="this.onCloseTabRequest($event)"
      (onHeaderChanged)="this.onLayoutChanged()"
      (sortLayouts)="this.onSortLayoutsRequest()"
      (tabSelected)="this.onLayoutSelected($event)"
      [tabs]="this.layouts"
      id="layout-tabs"
    >
    </ets-layout-tabs>
    
    <div [ngStyle]="this.layoutSectionStyle">
      <ng-container *ngFor="let layout of this.layouts">
        <ets-layout (layoutChanged)="this.onLayoutChanged()" [ngClass]="{'hidden': !layout.isActive}"
                    [rootSection]="layout"></ets-layout>
      </ng-container>
    </div>

    <!-- CR-20260922-001 — the Action Board wash: over the content only, never the tab bar / header /
         footer, never blocking (pointer-events: none). Gated by the panel's grant. -->
    <ets-action-board-overlay *ngIf="this.securityContext.actionBoard"
                              [activeLayoutTabId]="this.selectedLayout?.id"></ets-action-board-overlay>

  </div>
  
  <div class="ets-host-footer">
    
    <div class="footer-wrapper">
      
      <div class="section left">
        
        <div *ngIf="this.securityContext.sessionPnL" class="element session-pnl">
          <ets-pnl-box [pnl]="this.terminalSessionPnL" prefix="S"></ets-pnl-box>
        </div>
        
        <div *ngIf="this.securityContext.accumulatedPnL" class="element accumulated-pnl">
          <ets-pnl-box [pnl]="this.terminalAccumulatedPnL" prefix="A"></ets-pnl-box>
        </div>
        
        <div *ngIf="this.securityContext.gatewaysManager" class="element gateways">
          <ets-gateway-manager></ets-gateway-manager>
        </div>

        <div>
<!--          <ets-current-zone-indicator-component-2></ets-current-zone-indicator-component-2>-->
          <ets-current-zone-indicator-component></ets-current-zone-indicator-component>
        </div>

        <!-- CR-20260922-001 — the ACTION BOARD footer badge (outstanding count + one-click way into
             the board). HIDDEN by owner ruling 2026-09-22 ("remove the indicator at the bottom"), kept
             in code because it may come back. The login-time board read it used to do now lives in
             the overlay component.
        <div *ngIf="this.securityContext.actionBoard" class="element action-board-badge">
          <ets-action-board-footer-badge></ets-action-board-footer-badge>
        </div>
        -->
        
        <div *ngIf="this.securityContext.sessionMessages" class="element shell-messages">
          <ets-shell-messages-overlay></ets-shell-messages-overlay>
        </div>
        
        <div *ngIf="this.securityContext.totalStrategiesIssues" class="element strategy-issues">
          <ets-total-strategy-issues></ets-total-strategy-issues>
        </div>
        
        <div *ngIf="this.securityContext.unaccountedData" class="element unaccounted-data">
          <ets-unaccounted-data-indicator></ets-unaccounted-data-indicator>
        </div>

        <div class="element skew-sentiment">
          <ets-skew-sentiment-indicator></ets-skew-sentiment-indicator>
        </div>

        <div class="element h-skew">
          <ets-horizontal-skew-tray-indicator></ets-horizontal-skew-tray-indicator>
        </div>

      </div>
      
      <div class="section center">
        <div *ngIf="this.securityContext.currentMarketPrices" class="element prices">
          <div class="market-prices">
         
            <div class="price-box">
              <div class="ticker">
                <span>ES</span>
                <span class="star" *ngIf="this.isTheoreticalStream(this.currentEsContract)">*</span>
              </div>
              <div class="data">
                <ets-last-price
                  [showChange]="!this.isQgMode"
                  [showLabel]="false"
                  [asset]="this.currentEsContract"
                ></ets-last-price>
                <ng-container *ngIf="this.isQgMode">
                  <span>/</span>
                  <ets-last-price
                    [showChange]="true"
                    [showLabel]="false"
                    [qgLiveQuote]="true"
                    [asset]="this.currentEsContract"
                  ></ets-last-price>
                </ng-container>
              </div>
            </div>
            
            <div class="price-box framed" #spx>
              <ng-container *ngIf="true">
                <dx-popover
                  [target]="spx"
                  showEvent="dxhoverstart"
                  hideEvent="dxhoverend"
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-load-indicator [visible]="false"></dx-load-indicator>
                    <div class="settlement-price" style="padding: 10px; text-align: center">
                      <div class="label" style="font-weight: bold; margin-bottom: 5px;">Settlement Price</div>
                      <div class="price">{{ this.settlementPrice | number:'1.2-2' }}</div>
                    </div>
                  </div>
                </dx-popover>
              </ng-container>
              <div class="ticker">
                <span class="">SPX</span>
                <span class="star" *ngIf="this.isTheoreticalStream('SPX') || this.isAdjustedStream('SPX')">*</span>
              </div>
              <div class="data">
                <ets-last-price
                  [showChange]="!this.isQgMode"
                  [showLabel]="false"
                  [asset]="'SPX'"
                ></ets-last-price>
                <ng-container *ngIf="this.isQgMode">
                  <span>/</span>
                  <ets-last-price
                    [showChange]="true"
                    [showLabel]="false"
                    [qgLiveQuote]="true"
                    [asset]="'SPX'"
                  >
                  </ets-last-price>
                </ng-container>
              </div>
            </div>
            
            <div class="price-box">
              <div class="ticker">
                <span>SPY</span>
                <span class="star" *ngIf="this.isTheoreticalStream('SPY')">*</span>
              </div>
              <div class="data">
                <ets-last-price
                  [showChange]="!this.isQgMode"
                  [showLabel]="false"
                  [asset]="'SPY'"
                ></ets-last-price>
                <ng-container *ngIf="this.isQgMode">
                  <span>/</span>
                  <ets-last-price
                    [showChange]="true"
                    [showLabel]="false"
                    [qgLiveQuote]="true"
                    [asset]="'SPY'"
                  ></ets-last-price>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="section right">
        
        <div *ngIf="this.securityContext.quoteRateLimiter" class="element quote-rate-limiter">
          <ets-quote-rate-limiter-component></ets-quote-rate-limiter-component>
        </div>
        
        <div class="quote-counter" *ngIf="this.isSuperUser">
          <div>{{ this.quoteCounter || '*' }}</div>
          <div>Quotes Used</div>
        </div>
        
        <div class="element time-panel">
          <ets-server-time-panel *ngIf="this.securityContext.serverTimePanel">
          </ets-server-time-panel>
        </div>
      
      </div>
      
    </div>
  
  </div>
  
  <dx-popup [closeOnOutsideClick]="false" [dragEnabled]="false" [height]="250" [resizeEnabled]="false"
            [showTitle]="false"
            [visible]="this.groupExitDetails.isConfirmationVisible" [width]="300">
    <div *dxTemplate="let data of 'content'" id="group-exit_confirmation-dialog">
      <div id="group-exit_tree">
        <p>
          {{ this.groupExitDetails.message }}
        </p>
      </div>
      <div id="group-exit_buttons">
        <dx-button (onClick)="this.confirmGroupExit('yes')" text="Yes" type="normal" width="100"></dx-button>
        <dx-button (onClick)="this.confirmGroupExit('no')" text="Cancel" type="normal" width="100"></dx-button>
      </div>
    </div>
  </dx-popup>
  
  <ets-layouts-sort (sortLayouts)="this.onSortLayoutsCompleted($event)" [isVisible]="this.isLayoutsSortDialogVisible"
                    [layouts]="this.layouts"></ets-layouts-sort>

</div>

<ets-normalizing-calculator></ets-normalizing-calculator>
